import { Component } from 'react';
import { connect } from 'react-redux';
import { Tooltip } from 'react-tooltip';

import Icon from 'components/atoms/Icon';
import { OpenModal, RootState } from 'types';
import { SystemType } from 'types/system';
import { DateTimeFormat } from 'utils/dateTimeFormat';
import { checkDifferent } from 'utils/formHandlers';
import { translate } from 'utils/translate';
import { twclsx } from 'utils/twclsx';

interface StateIconProps {
    system: SystemType;
    openModelFunction: OpenModal;
    dateTimeFormat: DateTimeFormat;
}

interface StateIconState {
    system: SystemType;
}

class StateIcon extends Component<StateIconProps, StateIconState> {
    intervalId: NodeJS.Timeout | undefined;

    constructor(props: StateIconProps) {
        super(props);
        this.state = {
            system: props.system,
        };
    }

    static getDerivedStateFromProps(props: StateIconProps, state: StateIconState) {
        if (checkDifferent(props.system, state.system)) {
            return { system: props.system };
        }
        return null;
    }

    lastAISUpdate = () => {
        return (
            this.props.dateTimeFormat
                .parseDateTime()
                .getDiffInSeconds(this.state.system.update?.messages.valid_time_utc) / 60
        );
    };

    showAbout = () => {
        this.props.openModelFunction(
            'aboutModel',
            0,
            'medium',
            {},
            {
                onCancel: () => {
                    this.props.openModelFunction('aboutModel');
                },
            },
            true
        );
    };

    render() {
        return (
            <div
                onClick={this.showAbout}
                data-tooltip-id="systemUpdateTooltip"
                className="w-10 h-10 flex justify-center items-center"
            >
                {this.props.system.networkError ? (
                    <>
                        <Tooltip
                            id="systemUpdateTooltip"
                            html={`${translate(
                                'Oops! Looks like  there is a network issue. Please check your connection'
                            )}`}
                            place={'right'}
                        />
                        <Icon className={twclsx('w-8', 'h-8', 'text-red-500')}>
                            <path d="M6.528 6.536a6 6 0 0 0 7.942 7.933m2.247 -1.76a6 6 0 0 0 -8.427 -8.425" />
                            <path d="M12 3c1.333 .333 2 2.333 2 6c0 .337 -.006 .66 -.017 .968m-.55 3.473c-.333 .884 -.81 1.403 -1.433 1.559" />
                            <path d="M12 3c-.936 .234 -1.544 1.29 -1.822 3.167m-.16 3.838c.116 3.029 .776 4.695 1.982 4.995" />
                            <path d="M6 9h3m4 0h5" />
                            <path d="M3 20h7" />
                            <path d="M14 20h7" />
                            <path d="M10 20a2 2 0 1 0 4 0a2 2 0 0 0 -4 0" />
                            <path d="M12 15v3" />
                            <path d="M3 3l18 18" />
                        </Icon>
                    </>
                ) : (
                    <>
                        <Tooltip
                            id="systemUpdateTooltip"
                            html={`${translate('System info')}<br/><div>${translate('ais update', {
                                timeAgo: this.props.dateTimeFormat
                                    .parseDateTime()
                                    .timeAgo(this.state.system.update?.messages.valid_time_utc),
                            })} /  ${translate('environmental update', {
                                timeAgo: this.props.dateTimeFormat
                                    .parseDateTime()
                                    .timeAgo(this.state.system.update?.environmental.valid_time_utc),
                            })}</div>`}
                            place={'right'}
                        />
                        <Icon
                            className={twclsx(
                                'w-8',
                                'h-8',
                                this.lastAISUpdate() < 16
                                    ? 'text-green-500'
                                    : this.lastAISUpdate() < 32
                                    ? 'text-yellow-500'
                                    : 'text-red-500'
                            )}
                        >
                            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                            <path d="M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0" />
                            <path d="M12 9h.01" />
                            <path d="M11 12h1v4h1" />
                        </Icon>
                    </>
                )}
            </div>
        );
    }
}

const stateIconToProps = (state: RootState) => ({
    system: state.port.system,
    openModelFunction: state.layout.openModelFunction,
    dateTimeFormat: state.port.dateTimeFormat,
});

const stateIconDispatchToProps = () => ({});

export default connect(stateIconToProps, stateIconDispatchToProps)(StateIcon);
